import { Link } from "react-router-dom"

import { Header } from "shared/components/organisms/Header/Header"
import { Sidebar } from "shared/components/organisms/Sidebar/Sidebar"

import { ReactComponent as LeftArrow } from 'assets/icons/left-arrow.svg'

import { Article, CardTitle, Container, Content } from "./_howItWorks"

export const HowItWorks = () => {
  return (
    <Container>
      <Header />
      <Sidebar />

      <Content>
        <Link
          className="how-content__icon-container"
          to="/perfil"
        >
          <LeftArrow
            className="how-content__icon"
          />
        </Link>

        <CardTitle>
          <h1 className="how-card__title">
            Como funciona?
          </h1>
        </CardTitle>
          <Article>
            {`A Plataforma REPFY, possui duas categorias: CLIENTES e PARCEIROS. Ambas disponíveis nas modalidades Mobile e Web.

            PLATAFORMA CLIENTE

            O cliente faz o seu cadastro na plataforma, e sempre que precisar de um serviço, consegue solicitar um profissional, de forma emergencial ou agendada. O melhor é que o preço já simulado na hora em que a solicitação é feita, pois nem sempre é possível esperar horas ou dias por um orçamento não é mesmo?

            O pagamento é prático, podendo ser feito através do cartão de crédito pré-cadastrado, ou através de créditos comprados pelo aplicativo, então caso esteja sem a sua carteira ou dinheirvivo, isso também não será um problema!

            Toda validação do serviço, assim como o histórico, são documentados para segurança, além disso, a equipe REPFY monitora o deslocamento e o andamento dos atendimentos em tempo real enossa central de monitoramento.

            PLATAFORMA PARCEIROS

            O parceiro faz o seu cadastro na plataforma, monta sua precificação por categoria de serviços e preço de visita, e pronto. Após nossa análise de segurança e verificação, o parceiro habilitado a ser acionado via app, por parte dos clientes cadastrados na plataforma, podendo aceitar ou não aquela solicitação. Caso não aceite, o aplicativo ira procurar outrprestador mais próximo, cadastrado na plataforma, para o atendimento.

            Para mais informações, visite nosso FAQ entrando na aba de Suporte, acesse nosso site, ou entre em contato através do e-mail contato@repfy.com.br.
                `}
          </Article>
      </Content>
    </Container>
  )
}
